import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [{ title: 'Kogia | Privacy' }]

export default function PrivacyRoute() {
	return (
		<div className="mx-auto flex max-w-screen-lg flex-col gap-12 p-4 pb-20 md:pt-10">
			<div className="flex flex-col gap-2">
				<h2 className="mb-4 font-serif text-h2">
					<strong className="font-bold">Privacy Policy</strong>
				</h2>
				<p>Last updated: April 15th, 2024</p>
				<p>
					Kogia ("we," "our," or "us") is committed to protecting the privacy of
					individuals who use our website and services. This Privacy Policy
					outlines how we collect, use, disclose, and protect personal
					information provided by users of our image library for ocean
					conservation.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						1. Information We Collect
					</strong>
				</p>
				<p>
					We collect personal information provided voluntarily by users when
					they register for an account, submit media, or communicate with us.
					This information may include:
				</p>
				<ul className="list-inside list-[auto]">
					<li>Name</li>
					<li>Email address</li>
					<li>Organization name (if applicable</li>
					<li>User-generated content such as comments or contributions</li>
				</ul>
				<p>
					We may also collect non-personal information such as IP addresses,
					browser type, and device information for analytical purposes.
				</p>
				<p>
					<strong className="text-h5 font-bold">2. Use of Information</strong>
				</p>
				<p>We use the collected information for the following purposes:</p>
				<ul className="list-inside list-[auto]">
					<li>To provide and maintain our image library services</li>
					<li>
						To communicate with users about their accounts and submissions
					</li>
					<li>To improve our website and services</li>
					<li>To analyze usage trends and preferences</li>
					<li>To prevent fraud and ensure security</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">
						3. Disclosure of Information
					</strong>
				</p>
				<p>
					We may disclose personal information to third-party service providers
					who assist us in operating our website and providing services. These
					service providers are obligated to protect the confidentiality and
					security of personal information.
				</p>
				<p>
					We may also disclose personal information when required by law or in
					response to valid legal requests, such as subpoenas or court orders.
				</p>
				<p>
					<strong className="text-h5 font-bold">4. Data Security</strong>
				</p>
				<p>
					We implement appropriate technical and organizational measures to
					protect personal information from unauthorized access, disclosure,
					alteration, or destruction. However, no method of transmission over
					the internet or electronic storage is completely secure, and we cannot
					guarantee absolute security.
				</p>
				<p>
					<strong className="text-h5 font-bold">5. User Rights</strong>
				</p>
				<p>
					Users have the right to access, update, or delete their personal
					information at any time. Users may also opt out of receiving
					communications from us by following the unsubscribe instructions
					provided in emails or by contacting us directly.
				</p>
				<p>
					<strong className="text-h5 font-bold">6. Third-Party Links</strong>
				</p>
				<p>
					Our website may contain links to third-party websites or services that
					are not operated by us. We have no control over, and assume no
					responsibility for, the content, privacy policies, or practices of any
					third-party sites or services.
				</p>
				<p>
					<strong className="text-h5 font-bold">7. Children's Privacy</strong>
				</p>
				<p>
					Our services are not directed to individuals under the age of 13, and
					we do not knowingly collect personal information from children. If you
					are a parent or guardian and become aware that your child has provided
					us with personal information, please contact us to have it removed
					from our systems.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						8. Newsletter Subscription
					</strong>
				</p>
				<p>
					By signing up as a member of Kogia, users are automatically subscribed
					to our newsletter. Users can unsubscribe from the newsletter at any
					time by following the instructions provided in the newsletter or by
					contacting us directly.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						9. Changes to this Privacy Policy
					</strong>
				</p>
				<p>
					We may update this Privacy Policy from time to time by posting the
					revised version on our website. The effective date of the revised
					policy will be indicated at the top of the page. We encourage users to
					review this Privacy Policy periodically for any changes.
				</p>
				<p>
					<strong className="text-h5 font-bold">10. Contact Us</strong>
				</p>
				<p>
					If you have any questions or concerns about this Privacy Policy or our
					privacy practices, please contact us at{' '}
					<a
						// eslint-disable-next-line
						href={`mailto:info@kogia.org`}
						className="underline"
						target="_blank"
						rel="noreferrer"
					>
						info@kogia.org
					</a>
					.
				</p>
			</div>
		</div>
	)
}
